import { render, staticRenderFns } from "./checkVerified.vue?vue&type=template&id=3cb9cafb&scoped=true&"
import script from "./checkVerified.vue?vue&type=script&lang=js&"
export * from "./checkVerified.vue?vue&type=script&lang=js&"
import style0 from "./checkVerified.vue?vue&type=style&index=0&id=3cb9cafb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb9cafb",
  null
  
)

export default component.exports